import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-8" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Nom de l'organe "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Position "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between align-items-center mb-15" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "fw-semibold text-black" }, "Postes de l’organe")
  ])
], -1)
const _hoisted_11 = { class: "fw-bold mb-10 text-primary" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = { class: "form-group mb-10" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-5" }, [
  /*#__PURE__*/_createTextVNode(" Nom du poste "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_16 = ["onUpdate:modelValue"]
const _hoisted_17 = { class: "col-md-3" }
const _hoisted_18 = { class: "form-group mb-10" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-5" }, " Numéro d'ordre ", -1)
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = { class: "col-md-3" }
const _hoisted_22 = { class: "form-group mb-10" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-5" }, " Niveau ", -1)
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = { class: "col-md-3" }
const _hoisted_26 = { class: "form-group mb-10" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-5" }, [
  /*#__PURE__*/_createTextVNode(" Arrondissement "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" })
], -1)
const _hoisted_28 = {
  key: 0,
  class: "col-md-1 d-flex align-items-end mb-15"
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete" }, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "col-md-12 text-end mb-15" }
const _hoisted_33 = { class: "col-md-12 mt-15" }
const _hoisted_34 = { class: "d-flex align-items-center" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("button", {
  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 rounded-1 fs-md-15 bg-success",
  type: "submit"
}, " Mettre à jour ", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-1" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "organeForm",
        onSubmit: _ctx.updateOrgane,
        "validation-schema": _ctx.organeSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_Field, {
                  name: "nom",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer le nom de l'organe",
                  modelValue: _ctx.organe.nom,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.organe.nom) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "nom",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_Field, {
                  name: "position",
                  type: "number",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer la position de l'organe",
                  modelValue: _ctx.organe.position,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.organe.position) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "position",
                  class: "text-danger"
                })
              ])
            ]),
            _hoisted_10,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.postes, (poste, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "col-md-12 border rounded p-15 mb-15 bg-light"
              }, [
                _createElementVNode("h6", _hoisted_11, "Poste " + _toDisplayString(index + 1), 1),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": ($event: any) => ((poste.nomPoste) = $event),
                        type: "text",
                        class: "form-control shadow-none text-black",
                        placeholder: "Ex: Maire, Conseiller..."
                      }, null, 8, _hoisted_16), [
                        [_vModelText, poste.nomPoste]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": ($event: any) => ((poste.numeroOrdre) = $event),
                        type: "number",
                        min: "1",
                        class: "form-control shadow-none text-black bg-light",
                        readonly: ""
                      }, null, 8, _hoisted_20), [
                        [
                          _vModelText,
                          poste.numeroOrdre,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": ($event: any) => ((poste.niveau) = $event),
                        type: "number",
                        min: "1",
                        class: "form-control shadow-none text-black bg-light"
                      }, null, 8, _hoisted_24), [
                        [
                          _vModelText,
                          poste.niveau,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _hoisted_27,
                      _createVNode(_component_Multiselect, {
                        modelValue: poste.arrondissementId,
                        "onUpdate:modelValue": ($event: any) => ((poste.arrondissementId) = $event),
                        options: _ctx.arrondissementsOptions,
                        label: "label",
                        "track-by": "value",
                        placeholder: "Sélectionner un arrondissement",
                        searchable: true,
                        class: "shadow-none"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                    ])
                  ]),
                  (index !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-danger btn-sm",
                          onClick: ($event: any) => (_ctx.supprimerPoste(index))
                        }, _hoisted_31, 8, _hoisted_29)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-success btn-sm",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.ajouterPoste && _ctx.ajouterPoste(...args)))
              }, " + Ajouter un poste ")
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createVNode(_component_router_link, {
                  to: "/liste-organes",
                  class: "btn btn-danger transition border-0 lh-1 fw-medium"
                }, {
                  default: _withCtx(() => [
                    _hoisted_36,
                    _createTextVNode(" Annuler ")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}